import React, { forwardRef } from 'react';
import { styles } from './ModalContent.styles.js';
import { classNames } from '../../../../utils/common/styling.js';

var ModalContent = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { tabIndex: -1, ref: ref, className: classNames(styles.root, className) }, children));
});
ModalContent.displayName = "ModalContent";

export { ModalContent as default };
//# sourceMappingURL=ModalContent.js.map
